module.exports = __webpack_public_path__ + "img/feather-quill.c82f178d.png";